import { render, staticRenderFns } from "./UsersUpdate.vue?vue&type=template&id=2b8c02db&scoped=true&"
import script from "./UsersUpdate.vue?vue&type=script&lang=js&"
export * from "./UsersUpdate.vue?vue&type=script&lang=js&"
import style0 from "./UsersUpdate.vue?vue&type=style&index=0&id=2b8c02db&prod&lang=scss&scoped=true&"
import style1 from "./UsersUpdate.vue?vue&type=style&index=1&id=2b8c02db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8c02db",
  null
  
)

export default component.exports